import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {connect} from "react-redux";
import {actions} from "../../actions";
import _ from 'lodash';

import ArtifactScoreRow from './ArtifactScoreRow';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class ArtifactScoreTable extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 100,
            artifacts: [],
            numArtifacts: 0
        };
    };

    componentDidMount(){
        if(this.props.changed) {
            this.props.fetchArtifacts(this.props.form)
                .then(() => {
                    if(this.props.artifacts) {
                        this.setState({artifacts: this.props.artifacts})
                    }
                })
        } else {
            if (this.props.artifacts.length > 0) {
                this.setState({artifacts: this.props.artifacts})
            } else {
                this.props.fetchArtifacts(this.props.form)
                    .then(() => {
                        if(this.props.artifacts) {
                            this.setState({artifacts: this.props.artifacts})
                        }
                    })
            }
        }
    }

    renderRows(list) {
        if(list.length > 0) {
            let slicedList = list.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage);
            return _.map(slicedList, row => {
                let course = this.props.form.courses.find(x => x.canvas_course_id === row.canvas_course_id);
                row.course_code = course.course_code;
                row.name = course.name;
                return (
                    <ArtifactScoreRow key={row.canvas_submission_id + '-' + row.canvas_user_id} row={row}/>
                );
            })
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Course Code</TableCell>
                            <TableCell>Course Name</TableCell>
                            <TableCell>Assignment Name</TableCell>
                            <TableCell>Average Score</TableCell>
                            <TableCell>Max Possible Score</TableCell>
                            <TableCell>Artifact ID</TableCell>
                            <TableCell>Artifact</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.renderRows(this.props.artifacts)}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return { form: state.newAssessmentForm, artifacts: state.artifacts };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(ArtifactScoreTable));
